import { render, staticRenderFns } from "./LandingBanigualdad.vue?vue&type=template&id=39a225fc&"
import script from "./LandingBanigualdad.vue?vue&type=script&lang=ts&"
export * from "./LandingBanigualdad.vue?vue&type=script&lang=ts&"
import style0 from "./LandingBanigualdad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports